import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    signatureNav: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 2),
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    pageButton: {
        margin: '0 4px'
    }
}));

const SignatureNavigation = ({ pages, onPageClick }) => {
    const classes = useStyles();

    return (
        <div className={classes.signatureNav}>
            <Typography variant="subtitle2" style={{ marginRight: 8 }}>
                Signature Fields on Pages:
            </Typography>
            {pages.map(page => (
                <Button
                    key={`nav_${page}`}
                    size="small"
                    variant="outlined"
                    onClick={() => onPageClick(page)}
                    className={classes.pageButton}
                >
                    {page}
                </Button>
            ))}
        </div>
    );
};

export default SignatureNavigation;